module.exports = __webpack_public_path__ + "toBride1-we-y-n.842586b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-y-n.jpg
// module id = QVx7
// module chunks = 0